var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3100",
    "data-name": "Group 3100",
    transform: "translate(0.429 0.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M156.31,199.625a.939.939,0,0,0-1.328-1.328l-4.481,4.49-1.674-1.684a.939.939,0,1,0-1.328,1.328l2.339,2.339h0a.935.935,0,0,0,1.328,0Z",
    transform: "translate(-141.822 -191.307)",
    fill: "#1d1f24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    transform: "translate(-0.429 -0.485)",
    fill: "none",
    stroke: "#1d1f24",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.15,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3100);
export default __webpack_public_path__ + "static/media/Group_3100.e37cfc7eb6ba407cce95b9a5294f93b5.svg";
export { ForwardRef as ReactComponent };